// material-ui
import { Theme, useMediaQuery, Box } from '@mui/material';
import { Grid } from '@mui/system';

// project import
import Profile from './Profile';
import MobileSection from './MobileSection';

// trendio-selfcare-ui-kit
import { DrawerHeader, MenuOrientation, FullScreen, useConfig } from '@trendiolive/trendio-selfcare-ui-kit';

import UserMerchantsList from './UserMerchantsList';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { menuOrientation } = useConfig();

  const screenSmallerThanLg = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  if (screenSmallerThanLg) {
    return (
      <>
        <Box sx={{ width: '100%', ml: 1 }} />
        <MobileSection />
      </>
    );
  } else {
    return (
      <Grid container justifyContent={'flex-end'} alignItems={'center'} sx={{ gap: 2, width: '100%' }}>
        {menuOrientation === MenuOrientation.HORIZONTAL && <DrawerHeader open={true} />}
        <FullScreen />
        <UserMerchantsList />
        <Profile />
      </Grid>
    );
  }
}
